import React from 'react';

export const EllipsisOutlinedIcon = ({ width, height, fill, ...rest }) => {
  return (
    <svg
      viewBox='64 64 896 896'
      focusable='false'
      width={width}
      height={height}
      className='icon icon-ellipsis-outlined'
      {...rest}
    >
      <path
        fill={fill}
        d='M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z'
      />
    </svg>
  );
};

EllipsisOutlinedIcon.defaultProps = {
  width: 16,
  height: 16,
  fill: 'currentColor'
};
